import { AbstractControl } from "@angular/forms";
import { subYears } from "date-fns";

export function cprValidator(control: AbstractControl): { nationalId: false } | { nationalIdAge: false } | null {
	if (control.value || control.value === 0) {
		const id = String(control.value).replace(/\s/g, "");

		const day = +id.substring(0, 2);
		const month = +id.substring(2, 4);
		const year = +id.substring(4, 6);
		const checkNumber = id.substring(6);

		const centuryIndicator = +id.substring(6, 7);
		const centuryBreak = centuryIndicator === 4 || centuryIndicator === 9 ? 36 : 57;

		const date = new Date(2000 + year, month - 1, day);

		if (
			isExceedingLength(id) ||
			date.getDate() !== day ||
			date.getMonth() !== month - 1 ||
			!checkNumber.match("[0-9]{4}")
		) {
			return { nationalId: false };
		}

		if (centuryIndicator < 4 || year > centuryBreak) {
			return null; // born 1800 - 1999, thus definitely older than 18
		}

		if (+subYears(new Date(), 18) < +date) {
			return { nationalIdAge: false };
		}
	}

	return null;
}

function isExceedingLength(input: string): boolean {
	if (input.length > 11) {
		return true;
	} else if (input.length === 11) {
		return !/[-+]/.test(input);
	}
	return false;
}
